import { app } from '../../../app';

class SoftwareLicenseManagementService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getSoftwareLicenseManagementInfos(companyId) {
        const url = `app/rest/v2/company/${companyId}/softwarelicensemanagement`;
        return this.$http.get(url).then(({data}) => data);
    }

    getAssignableApplications(companyId) {
        const url = `app/rest/v2/company/${companyId}/softwarelicensemanagement/applications`;
        return this.$http.get(url).then(({data}) => data);
    }

    createSoftwareLicenseManagementInfo(companyId, slmiDTO) {
        const url = `app/rest/v2/company/${companyId}/softwarelicensemanagement`;
        return this.$http.put(url, slmiDTO).then(({data}) => data);
    }

    updateSoftwareLicenseManagementInfo(companyId, slmiDTO) {
        const url = `app/rest/v2/company/${companyId}/softwarelicensemanagement`;
        return this.$http.post(url, slmiDTO).then(({data}) => data);
    }

    deleteSoftwareLicenseManagementInfo(companyId, slmiId) {
        const url = `app/rest/v2/company/${companyId}/softwarelicensemanagement/${slmiId}`;
        return this.$http.delete(url).then(({data}) => data);
    }

}

app.service('SoftwareLicenseManagementService', SoftwareLicenseManagementService);



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/software-license-management.service.js